import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type PopupContent = {
  popupContent: any[],
  popupAtStep3: any[],
  popupAtDetail: any[],
}

const initialState: PopupContent = {
  popupContent: [],
  popupAtStep3: [],
  popupAtDetail: [],
}

const popupContentManagementSlice = createSlice({
  name: 'popupContentManagement',
  initialState,
  reducers: {
    addPopupContent: (state, action: PayloadAction<any>) => {
      state.popupContent.push(action.payload.data)
    },
    updateListPopupAtStep3: (state, action: PayloadAction<any>) => {
      state.popupAtStep3 = action.payload.data
    },
    updateListPopupAtDetail: (state, action: PayloadAction<any>) => {
      state.popupAtDetail = action.payload.data
    }
  },
  extraReducers: () => {},
})

export const popupContentManagementActionsCreator = popupContentManagementSlice.actions

export default popupContentManagementSlice
